export interface AppError {
  message: string;
}

export function mkError(message: string): AppError {
  return { message };
}
